import { render, staticRenderFns } from "./InsuredSubject.vue?vue&type=template&id=5f30e2ce"
import script from "./InsuredSubject.vue?vue&type=script&lang=js"
export * from "./InsuredSubject.vue?vue&type=script&lang=js"
import style0 from "./InsuredSubject.vue?vue&type=style&index=0&id=5f30e2ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports